import { render, staticRenderFns } from "./ticketVersionSetTemplateSave.vue?vue&type=template&id=1575d0a9&"
import script from "./ticketVersionSetTemplateSave.vue?vue&type=script&lang=js&"
export * from "./ticketVersionSetTemplateSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports